
<div class="top-row-controls-container" *ngIf="item.paginate_results||item.allow_searching||item.load_more">
<scaffold-search-bar
  *ngIf="item.allow_searching"
  [forceOnlyActive]="item?.force_only_active_items"
  [displayActiveStateFilter]="item?.display_active_state_filter"
  [allowSearch]="item.allow_searching"
  [hideTermSelect]="item.hide_terms"
  (search)="search($event)"
  [searchData]="this.item.columns"
></scaffold-search-bar>

<div *ngIf="item.load_more &&item.allow_searching && !item.paginate_results &&getCountLabel()" style="text-align: center">
  {{ getCountLabel() }}
</div>

<scaffold-paginate-page-select
  *ngIf="item.paginate_results"
  [perPageOptions]="item?.pageCounts"
  (perPageChange)="perPageChange($event)"
  [(perPage)]="perPage"
  [countLabel]="getCountLabel()"
></scaffold-paginate-page-select>
</div>

<div class="loading-table-wrapper">
  <div class="loading-table-overlay-spinner-container" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
  </div>
  <div [ngClass]="{ 'loading-table-overlay': isLoading }">

<div class="scaffold-data-list"
     [ngClass]="{ 'no-border-list': item.hide_border }"
     #tabtop>
  <div style="text-align: right"
       *ngIf="item.allow_add && !item.add_between"
       [ngClass]="{ 'pull-right': item.is_horizontal }">
    <scaffold-add-button-menu [add_label]="item.button_title"
                              [types]="item.list_view"
                              [disabled]="checkDisable()"
                              [use_icon]="item.use_icon"
                              (addNew)="addNew($event)"
                              [showPaginate]="item.paginate_results"></scaffold-add-button-menu>
  </div>
  <div style="padding-top: 25px"
       *ngIf="item.allow_add && item.add_between"></div>
  <h2 *ngIf="item.heading">{{ item.heading }} + 5 + 6</h2>
  <div class="align-center fa-2x" *ngIf="loading">
    <scaffold-loading-animation></scaffold-loading-animation>
  </div>
  <div *ngIf="view && !item.tab_view">
    <div class="scaffold-list-holder"
         [ngClass]="{
         'horizontal-list' : item.is_horizontal,
         'horizontal-list-1' : view && view.length <= 1,
        'horizontal-list-2': view && view.length == 2,
        'no-wrap-list': item.prevent_wrap,
        'block-add-button': item.use_block_button
      }"
    >
      <p *ngIf="item.search_load && !view?.length" style="padding: 0 20px">
        {{'items_no_search_made_yet'| translation}}
      </p>
      <div
        class="scaffold-list-item"
        [style]="getWidth()"
        *ngFor="let ite of view; trackBy: trackByFn; let $i = index"
        [ngClass]="{
          'list-current-active': ite === moveList.item,
          'move-highlight-before': ite.highlit_before,
          'move-highlight-after': ite.highlit_after
        }"
      >
        <div
          class="scaffold-move-buttons"
          (mouseover)="toggleMenu(true, 'hovered', ite)"
          (mouseout)="toggleMenu(false, 'hovered', ite)"
          [ngClass]="{ 'button-menu-hovered': ite.hovered || ite.menu_open }"
        >
          <hr
            [ngClass]="{ 'line-highlight': item.add_between }"
            *ngIf="!item.is_horizontal && !item.hide_seperator"
          />
          <button
            class="scaffold-list-insert"
            *ngIf="
              (moveList.movingItem &&
                moveList.movingItem.id !== info.id &&
                ite &&
                ite.id !== moveList.movingItem.id &&
                isType(moveList.movingItem.type) &&
                (movingIndex() == -1 || movingIndex() + 1 != $i)) ||
              itemToDuplicate
            "
            nbButton
            status="info"
            (click)="insertItem($i)"
            [title]="'insert_before'|translation"
            [disabled]="checkDisable()"
          >
            {{'insert'| translation}}
          </button>
          <button
            class="scaffold-list-insert scaffold-list-cancel"
            *ngIf="
              moveList.movingItem && ite && ite.id === moveList.movingItem.id
            "
            nbButton
            status="primary"
            (click)="cancelListMove(ite)"
            [title]="'cancel_move'|translation"
          >
            {{'cancel_move'| translation}}
          </button>
          <div
            class="add-new-menu"
            *ngIf="
              item.allow_add &&
              item.add_between &&
              !moveList.movingItem &&
              !itemToDuplicate
            "
          >
            <div
              *ngIf="!this.item.use_custom_buttons"
              class="btw-button-holder"
            >
              <scaffold-add-button-menu
                [add_label]="item.button_title"
                [blockButton]="item.use_block_button"
                [types]="item.list_view"
                (addNew)="addNew($event)"
                [disabled]="checkDisable()"
                [use_icon]="true"
                [index]="$i + 1"
              ></scaffold-add-button-menu>
            </div>
            <div *ngIf="this.item.use_custom_buttons" class="btw-button-holder">
              <scaffold-add-button-menu
                [add_label]="item.button_title"
                [blockButton]="item.use_block_button"
                [types]="item.custom_buttons"
                (addNew)="addNew($event)"
                [disabled]="checkDisable()"
                [use_icon]="true"
                [index]="$i + 1"
              ></scaffold-add-button-menu>
            </div>
          </div>
        </div>
        <div
          class="add-placeholder"
          *ngIf="
            (moveList.movingItem || item.add_between) &&
            (!moveList.movingItem ||
              !ite ||
              ite.id != moveList.movingItem.id) &&
            (movingIndex() == -1 || movingIndex() + 1 != $i)
          "
        >
          <div class="color-bar"></div>
        </div>

        <div
          class="flex-list flex-center"
          inViewport
          [inViewportOptions]="{ threshold: [400] }"
          (inViewportAction)="onIntersection($event, ite)"
        >
          <div
            style="flex: 1; padding-left: 0 10px; max-width: 100%; min-width: 0"
          >
            <app-view
              [info]="ite"
              *ngIf="ite && ite.data"
              [childview]="ite.childview || []"
              [items]="ite.data.content"
              [data]="item_data[$i]"
              (deleteDataEvent)="deleteHandler($event)"
              (openViewHandler)="openViewHandler($event, ite)"
              (openLinkHandler)="openLinkHandler($event, ite)"
            ></app-view>
          </div>
        </div>
      </div>
      <div
        class="scaffold-list-item"
        *ngIf="item.inline_create && view.length == 0"
      >
        <app-add-data-inline
          [data]="inline_data"
          [item]="item"
          (updated)="redraw()"
        ></app-add-data-inline>
      </div>

      <div class="scaffold-list-item">
        <div
          class="scaffold-move-buttons"
          (mouseover)="toggleMenu(true, 'last_hovered')"
          (mouseout)="toggleMenu(false, 'last_hovered')"
          [ngClass]="{
            'button-menu-hovered':
              last_hovered || last_menu_open || (view && view.length == 0)
          }"
        >
          <hr
            [ngClass]="{ 'line-highlight': item.add_between }"
            *ngIf="!item.is_horizontal && !item.hide_seperator"
          />
          <button
            class="scaffold-list-insert"
            *ngIf="
              (moveList.movingItem &&
                moveList.movingItem.id !== info.id &&
                isType(moveList.movingItem.type)) ||
              itemToDuplicate
            "
            nbButton
            status="info"
            (click)="insertItem(view.length)"
            [nbTooltip]="'insert_before'|translation"
            nbTooltipPlacement="above"
            [disabled]="checkDisable()"
          >
            {{'insert'| translation}}
          </button>
          <div
            class="add-new-menu"
            *ngIf="
              item.allow_add &&
              item.add_between &&
              !moveList.movingItem &&
              !itemToDuplicate
            "
          >
            <div
              *ngIf="!this.item.use_custom_buttons"
              class="btw-button-holder"
            >
              <scaffold-add-button-menu
                [add_label]="item.button_title"
                [blockButton]="item.use_block_button"
                [types]="item.list_view"
                (addNew)="addNew($event)"
                [disabled]="checkDisable()"
                [use_icon]="true"
                [index]="$i + 1"
              ></scaffold-add-button-menu>
            </div>
            <div *ngIf="this.item.use_custom_buttons" class="btw-button-holder">
              <scaffold-add-button-menu
                [add_label]="item.button_title"
                [blockButton]="item.use_block_button"
                [types]="item.custom_buttons"
                (addNew)="addNew($event)"
                [disabled]="checkDisable()"
                [use_icon]="true"
                [index]="$i + 1"
              ></scaffold-add-button-menu>
            </div>
          </div>
        </div>
        <div
          class="add-placeholder"
          *ngIf="moveList.movingItem || item.add_between"
        >
          <div class="color-bar"></div>
        </div>
      </div>
    </div>
    <scaffold-paginator *ngIf="item.paginate_results && (active-1||listTotalNumberOfItems || listTotalNumberOfItems > perPage||listTotalNumberOfItems===null)"
                        [itemCount]="listTotalNumberOfItems"
                        [(activePage)]="active"
                        [perPage]="perPage"></scaffold-paginator>
  </div>
  <div *ngIf="view && item.tab_view" (click)="initiated()">
    <nb-tabset fullWidth>
      <nb-tab *ngFor="let ite of view; trackBy: trackByFn; let $i = index"
              [tabTitle]="ite.title">
        <div *ngIf="item.inline_create && view.length == 0 && !checkDisable()">
          <button nbButton
                  status="primary"
                  *ngIf="checkKeys(item_data[$i])"
                  (click)="save(item_data[$i], ite)"
                  [disabled]="hasErrors(item_data[$i]) || checkDisable()">
            {{'create'| translation}}
          </button>
        </div>
        <app-view [info]="ite"
                  *ngIf="ite && ite.data"
                  [childview]="ite.childview || []"
                  [items]="ite.data.content"
                  [data]="item_data[$i]"
                  (deleteDataEvent)="deleteHandler($event)"
                  (openViewHandler)="openViewHandler($event, ite)"
                  (openLinkHandler)="openLinkHandler($event, ite)"></app-view>
      </nb-tab>
    </nb-tabset>
  </div>
  <div class="list-load-more-btn-wrapper" *ngIf="item?.load_more && !item.paginate_results && (!listTotalNumberOfItems || listTotalNumberOfItems > view.length) && (!listTotalNumberOfItems || listTotalNumberOfItems > (active-1)*perPage)">
    <div class="align-center fa-2x" *ngIf="loading">
      <scaffold-loading-animation></scaffold-loading-animation>
    </div>
  <button class="list-load-more-btn"
          nbButton
          size="medium"
          shape="semi-round"
          status="primary"
          aria-label="Load Items"
          (click)="loadMore()"
          [disabled]="loading"
          >
    <span>{{'load_more'| translation}}</span>

  </button>

</div>
</div>

  </div>
</div>